import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CampaignService} from '../service/campaign.service';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../../environments/environment';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {ClientServiceService} from '../../client/client-service/client-service.service';
import {first} from 'rxjs/operators';

declare var DDP_ENV: any;

@Component({
  selector: 'app-campaign-view',
  templateUrl: './campaign-view.component.html',
  styleUrls: ['./campaign-view.component.css']
})
export class CampaignViewComponent implements OnInit {

  loading: boolean;
  campaignList: any [];
  currentCampaign: any;
  closeResult: string;
  public reasonText: string = "";
  public confirmationCode: string = "";
  public reasonOption: string = "";
  mrn: any;
  status: string='';
  clientId: any;
  client: any;
  regExp: string='';
  itemsPerPage = 10;
  currentPage = 1;
  numberOfCampaigns: [];
  campaignTypeList: any = [
      { id: '1', value: 'MONITORING' },
      { id: '2', value: 'ACTIVATED' },
      { id: '3', value: 'EXPIRED' },
      { id: '4', value: 'SUSPENDED' },
      { id: '5', value: 'CANCELLED' }
  ];

  readonly qrDownloadURL = DDP_ENV.campaignUrl + '/qrcode/campaign/';

    constructor(private router: Router, private modalService: NgbModal,
              private campaignService: CampaignService, private clientService: ClientServiceService,
              private toastr: ToastrService,
              private _route: ActivatedRoute) {

        this._route.params.subscribe(routeParams => {this.mrn = routeParams.mrnParam; });
        this._route.params.subscribe(routeParams => {this.clientId = routeParams.clientIdParam; });
        this.clientId = this.clientId !== undefined ? this.clientId : localStorage.getItem('clientId');
        this.client = this.getClientDetails(this.clientId);
  }

  ngOnInit() {
    this.getAllCampaigns();
  }

   public getClientDetails(clientId: any) {
        this.clientService.getClientById(clientId)
            .pipe(first())
            .subscribe(data => {
              console.log('client ::' + data.json())
              this.client = data.json();
            }, (error) => {
              this.toastr.error('', 'Please try again');
            });
    }

    search() {
      console.log('' + this.regExp);
      this.getAllCampaigns();
    }


    onChangeStatusFilter(campaignStatus) {
        console.log(campaignStatus);

        if (campaignStatus === 'ALL') {
            this.getAllCampaigns();
        } else {
            this.getAllCampaignsByStatus(campaignStatus);
        }
    }

  pageChanged(event) {
      this.currentPage = event;
      this.getAllCampaigns();
      console.log(event);
    }

  public getAllCampaignsByStatus(searchByStatus) {
      this.status=searchByStatus;
      this.getAllCampaigns();
      this.status='';
  }

  public getAllCampaigns() {
    this.loading = true;
      if (this.clientId === undefined) {
          this.clientId = localStorage.getItem('clientId');
      }
    this.campaignService.getAllCampaigns(this.mrn, this.status, this.clientId, this.currentPage - 1 , this.itemsPerPage, this.regExp)
        .subscribe(data => {
          const response: any = data.json();
          this.campaignList = response.campaigns;
          this.numberOfCampaigns = response.numberOfCampaigns;
          this.loading = false;
          // TODO - Uncomment below code when using actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

    viewDevices(campaignId, campaignNumber, patientMRN) {
        // this.router.navigate( [ '/elasticcare/device-view' ], { fragment: campaignId } );
        this.router.navigate( [ '/elasticcare/device-view' , {campaignIdParam: campaignId, campaignNumberParam: campaignNumber, patientMRNParam: patientMRN}]);
    }

    viewEventLog(campaignId, campaignNumber) {
        this.router.navigate( [ '/elasticcare/eventlog-view' ], { queryParams: { campaignId: campaignId, campaignNumber: campaignNumber} } );
    }

    viewAlgorithmConfig(campaignId, campaignNumber) {
        this.router.navigate( [ '/elasticcare/algorithm' ], { queryParams: { campaignId: campaignId, campaignNumber: campaignNumber} } );
    }

    viewDataAvailable(campaignId, campaignNumber) {
        this.router.navigate( [ '/elasticcare/availabledata-view' ], { queryParams: { campaignId: campaignId, campaignNumber: campaignNumber} } );
    }

    downloadQRCode(campaignId) {
      console.log('download QR Code ' + campaignId);
      this.campaignService.downloadQR(campaignId)
          .subscribe(data => {
          }, (error) => {
              this.loading = false;
              // this.toastr.error('', 'Please try again');
          });
    }

    suspendCampaign(confirmSuspendCampaigm, campaign){
         this.reasonText = "";
        this.confirmationCode = "";
        this.currentCampaign = campaign;
        this.modalService.open(confirmSuspendCampaigm, {size: 'lg', ariaLabelledBy: 'modal-basic-title2'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;

            if (result === 'SaveSuspendCampaignClick') {
                    console.log("Suspend Campaign: " +this.currentCampaign.campaignNumber+", confirmationCode: "+this.confirmationCode+", Reason: "+this.reasonText);
                    const updateCampaignRequest = {
                          campaignId:this.currentCampaign.id,
                          campaignNumber:this.currentCampaign.campaignNumber,
                          clientId:this.currentCampaign.clientId,
                          reasonText:this.reasonText,
                          reasonCode: '',
                          confirmationCode:this.confirmationCode,
                          comment:'User requested to suspend campaign',
                          userId:''
                        };
                    this.campaignService.suspendCampaign(updateCampaignRequest)
                    .subscribe(data => {
                        this.toastr.success('', 'Campaign suspended successfully');
                        this.loading = false;
                        this.getAllCampaigns();
                    }, (error) => {
                        this.loading = false;
                        this.toastr.error('', 'Suspend Campaign Failed, Please try again');
                    });
            }
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    showCampaignHistory(campaignHistory, campaign){
        this.currentCampaign = campaign;
        this.modalService.open(campaignHistory, {size: 'lg', ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {

        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return  `with: ${reason}`;
        }
    }

}
